/**
 * Created by Daniel Wang on 1/15/2024.
 * Description: Component for store cache to file
 * ------ maintenance history ------
 */

import { Component, OnDestroy, OnInit } from '@angular/core';

import { CacheType, StoreCacheToFile } from '../../../../tamalelibs/models/admin-page.model';
import { AdminPagesService } from '../../../../tamalelibs/services/admin-page.service';
import { DateHelperService } from '../../../../tamalelibs/services/date-helper.service';

@Component({
    selector: 'tam-store-cache-to-file',
    templateUrl: './store-cache-to-file.component.html',
    styleUrls: ['./store-cache-to-file.component.scss']
})
export class StoreCacheToFileComponent implements OnInit, OnDestroy {
    // #region public properties
    data: Array<StoreCacheToFile> = [];
    // #endregion

    // #region private properties
    // #endregion

    // #region constructor
    constructor(
        private _adminPagesServcie: AdminPagesService,
        private _dateHelpService: DateHelperService
    ) { }
    // #endregion

    // #region angular functions
    ngOnInit() {
        if (!this.data) {
            this.data = [];
        }
        Object.values(CacheType).forEach(item => {
            const storeCacheToFile = new StoreCacheToFile();
            storeCacheToFile.cacheType = item;
            storeCacheToFile.filePath = '/home/tsdata';
            const currentDate = new Date();
            const yyyy = currentDate.getFullYear();
            const mm = currentDate.getMonth() + 1;
            let mm2 = '';
            const dd = currentDate.getDate();
            let dd2 = '';
            const hour = currentDate.getHours();
            let hour2 = '';
            const mins = currentDate.getMinutes();
            let mins2 = '';
            if (dd < 10) {
                dd2 = '0' + dd;
            } else {
                dd2 = dd.toString();
            }
            if (mm < 10) {
                mm2 = '0' + mm;
            } else {
                mm2 = mm.toString();
            }
            if (hour < 10) {
                hour2 = '0' + hour;
            } else {
                hour2 = hour.toString();
            }
            if (mins < 10) {
                mins2 = '0' + mins;
            } else {
                mins2 = mins.toString();
            }
            const parameter = yyyy + '' + mm2 + '' + dd2 + '-' + hour2 + '' + mins2;
            if (item === CacheType.Notification) {
                storeCacheToFile.fileName = 'notif_cache_data-' + parameter + '.xml';
            } else if (item === CacheType.Preferences) {
                storeCacheToFile.fileName = 'pref_cache_data-' + parameter + '.xml';
            } else if (item === CacheType.Entries) {
                storeCacheToFile.fileName = 'entry_cache_data-' + parameter + '.xml';
            } else if (item === CacheType.Contacts) {
                storeCacheToFile.fileName = 'contact_cache_data-' + parameter + '.xml';
            }
            this.data.push(storeCacheToFile);
        });
    }

    ngOnDestroy(): void {
    }
    // #endregion

    // #region public functions

    // #endregion

    // #region private functions

    // #endregion
}
